

export const AGENDA_CALENDARHEADER_TITLE = 'title';
export const AGENDA_CALENDARHEADER_PREV = 'prev';
export const AGENDA_CALENDARHEADER_NEXT = 'next';
export const AGENDA_CALENDARHEADER_PREVYEAR = 'prevYear';
export const AGENDA_CALENDARHEADER_NEXTYEAR = 'nextYear';
export const AGENDA_CALENDARHEADER_TODAY = 'today';
export const AGENDA_CALENDARVIEW_MONTH = 'month';
export const AGENDA_CALENDARVIEW_BASICWEEK = 'basicWeek';
export const AGENDA_CALENDARVIEW_BASICDAY = 'basicDay';
export const AGENDA_CALENDARVIEW_AGENDAWEEK = 'agendaWeek';
export const AGENDA_CALENDARVIEW_AGENDA2WEEK = 'agenda2Weeks';
export const AGENDA_CALENDARVIEW_AGENDA3WEEK = 'agenda3Weeks';
export const AGENDA_CALENDARVIEW_AGENDADAY = 'agendaDay';
export const AGENDA_CALENDARVIEW_AGENDA5DAY = 'agenda5Days';
export const AGENDA_CALENDARVIEW_AGENDA6DAY = 'agenda6Days';
export const AGENDA_CALENDARVIEW_LISTYEAR = 'listYear';
export const AGENDA_CALENDARVIEW_LISTSEARCH = 'listSearch'; // Custom list view for search results with extended range
export const AGENDA_CALENDARVIEW_LISTMONTH = 'listMonth';
export const AGENDA_CALENDARVIEW_LISTWEEK = 'listWeek';
export const AGENDA_CALENDARVIEW_LISTDAY = 'listDay';
export const AGENDA_CALENDARVIEW_TIMELINEDAY = 'timelineDay';
export const AGENDA_CALENDARVIEW_TIMELINEWEEK = 'timelineWeek';
export const AGENDA_CALENDARVIEW_TIMELINEMONTH = 'timelineMonth';
export const AGENDA_CALENDARVIEW_TIMELINEYEAR = 'timelineYear';
export const AGENDA_HATCH_STYLE_DOTTEDGRID = 'DottedGrid';
export const AGENDA_HATCH_STYLE_BACKWARDDIAGONAL = 'BackwardDiagonal'
export const AGENDA_MOMENT_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const AGENDA_DURATION_DEFAULT = 15;
export const AGENDA_SLOT_DURATION = [
    { "KeyName": "AgendaSlotDurationMinutes","KeyValue": "SixtyMinutes", "label":60 },
    { "KeyName": "AgendaSlotDurationMinutes","KeyValue": "ThirtyMinutes", "label":30 },
    { "KeyName": "AgendaSlotDurationMinutes","KeyValue": "TwentyMinutes", "label":20 },
    { "KeyName": "AgendaSlotDurationMinutes","KeyValue": "FifteenMinutes", "label":15 },
    { "KeyName": "AgendaSlotDurationMinutes","KeyValue": "TenMinutes", "label":10 },
    { "KeyName": "AgendaSlotDurationMinutes","KeyValue": "SixMinutes", "label":6 },
    { "KeyName": "AgendaSlotDurationMinutes","KeyValue": "FiveMinutes", "label":5 },
];

export const AGENDA_ACTION_TYPE = {
	SHOW_PERSON: 1,
	SHOW_PROPERTY: 2,
	CHANGE_STATUS: 3,
	CONFIRMATION: 4,
	MESSAGE: 5,
    MAIL_TO_OWNER: 6,
	DELETE: 7,
};

export enum AGENDA_VIEW_TYPE {
    AGENDA_VIEW_DAY_TYPE = 0,
    AGENDA_CALENDARVIEW_AGENDA5DAY = 3,
    AGENDA_CALENDARVIEW_AGENDA6DAY = 5,
    AGENDA_CALENDARVIEW_AGENDAWEEK = 2,
    AGENDA_CALENDARVIEW_LISTMONTH = 4,
    AGENDA_CALENDARVIEW_MONTH = 1,
    AGENDA_CALENDARVIEW_LISTDAY = 6
}

export const AGENDA_VIEW_TYPE_OPTION  = {
    [AGENDA_VIEW_TYPE.AGENDA_VIEW_DAY_TYPE]: AGENDA_CALENDARVIEW_AGENDADAY,
    [AGENDA_VIEW_TYPE.AGENDA_CALENDARVIEW_AGENDA5DAY]: AGENDA_CALENDARVIEW_AGENDA5DAY,
    [AGENDA_VIEW_TYPE.AGENDA_CALENDARVIEW_AGENDA6DAY]: AGENDA_CALENDARVIEW_AGENDA6DAY,
    [AGENDA_VIEW_TYPE.AGENDA_CALENDARVIEW_AGENDAWEEK]: AGENDA_CALENDARVIEW_AGENDAWEEK,
    [AGENDA_VIEW_TYPE.AGENDA_CALENDARVIEW_LISTMONTH]: AGENDA_CALENDARVIEW_LISTMONTH,
    [AGENDA_VIEW_TYPE.AGENDA_CALENDARVIEW_MONTH]: AGENDA_CALENDARVIEW_MONTH,
    [AGENDA_VIEW_TYPE.AGENDA_CALENDARVIEW_LISTDAY]: AGENDA_CALENDARVIEW_LISTDAY
}